/* tslint:disable */
/* eslint-disable */
/**
 * New Train Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const GetAvailableStatus = {
    Both: 'Both',
    OnlyOneWay: 'OnlyOneWay',
    OnlyRoundTrip: 'OnlyRoundTrip'
} as const;

export type GetAvailableStatus = typeof GetAvailableStatus[keyof typeof GetAvailableStatus];



